export const dashboardStyles = {
  activityChartIcon: {
    marginTop: "-5px",
  },
  outboundInboundMessageContainer: {
    mb: 3,
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    flexWrap: "wrap",
  },
  highlightedWord: {
    fontWeight: 600,
    textDecoration: "underline",
    cursor: "help",
    color: "#1976d2",
  },
  tooltipContainer: {
    marginTop: "8px",
  },
  tooltipContentWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    fontSize: "14px",
    cursor: "help",
  },
  helpIcon: {
    fontSize: "1.2rem",
    color: "#1976d2",
    opacity: 0.7,
  },
  tabContextContainer: {
    width: "100%",
    typography: "body1",
  },
  tabListContainer: {
    borderBottom: 1,
    borderColor: "divider",
  },
  tab: {
    width: "200px",
    minWidth: "150px",
    fontSize: "0.875rem",
  },
  tabPanel: {
    marginBottom: "10px",
  },
  pocketLabTabPanel: {
    padding: 0,
  },
  IconsCount: {
    fontSize: "1rem",
    color: "text.secondary",
    ml: 0.5,
    cursor: "help",
  },
  dashboardCountContainer: {
    display: "flex",
    gap: 2,
    mb: 3,
    flexWrap: "wrap",
  },
  dashboardPaper: {
    flex: "1 1 0",
    minWidth: 160,
    p: 2,
    borderRadius: 2,
  },
  dashboardItem: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  dashboardCounter: {
    fontWeight: 600,
  },
};
